import { Plus, MessageSquare, Archive, Trash2 } from 'lucide-react';
import { Chat } from '../../types';

interface Props {
    chats: Chat[];
    currentChatId?: string;
    onSelectChat: (chat: Chat) => void;
    onNewChat: () => void;
    onDeleteChat: (chatId: string) => void;
}

export default function ChatSidebar({ chats, currentChatId, onSelectChat, onNewChat, onDeleteChat }: Props) {
    return (
        <div className="flex flex-col h-full bg-navy-100 dark:bg-navy-900 border-r border-navy-200 dark:border-navy-700 w-64">
            <div className="p-4">
                <button
                    onClick={onNewChat}
                    className="w-full flex items-center justify-center gap-2 px-4 py-2.5 btn-accent rounded-lg"
                >
                    <Plus className="w-4 h-4" />
                    Nova Conversa
                </button>
            </div>

            <div className="flex-1 overflow-y-auto">
                <div className="px-2 space-y-1">
                    {chats.map((chat) => (
                        <div
                            key={chat.id}
                            className={`group w-full flex items-center gap-3 px-3 py-3 text-sm rounded-xl transition-all duration-200 cursor-pointer ${currentChatId === chat.id
                                ? 'bg-white dark:bg-navy-800 shadow-md text-accent-600 dark:text-accent-400 border border-accent-400/30'
                                : 'text-navy-700 dark:text-navy-300 hover:bg-white/50 dark:hover:bg-navy-800/50'
                                }`}
                            onClick={() => onSelectChat(chat)}
                        >
                            <MessageSquare className={`w-4 h-4 flex-shrink-0 ${currentChatId === chat.id ? 'text-accent-500' : ''}`} />
                            <div className="flex-1 text-left truncate">
                                <span className="font-medium block truncate">{chat.title}</span>
                                <span className="text-xs text-navy-500 dark:text-navy-400">
                                    {new Date(chat.updatedAt).toLocaleDateString('pt-BR')}
                                </span>
                            </div>
                            {chat.isArchived && <Archive className="w-3 h-3 text-navy-400" />}
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (window.confirm('Tem certeza que deseja excluir esta conversa?')) {
                                        onDeleteChat(chat.id);
                                    }
                                }}
                                className="opacity-0 group-hover:opacity-100 p-1.5 hover:bg-error-100 dark:hover:bg-error-900/30 rounded-lg text-navy-400 hover:text-error-600 transition-all duration-200"
                                title="Excluir conversa"
                            >
                                <Trash2 className="w-4 h-4" />
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
